import { render, staticRenderFns } from "./im-file.vue?vue&type=template&id=af6ed9e8&scoped=true"
import script from "./im-file.vue?vue&type=script&lang=js"
export * from "./im-file.vue?vue&type=script&lang=js"
import style0 from "./im-file.vue?vue&type=style&index=0&id=af6ed9e8&prod&lang=css"
import style1 from "./im-file.vue?vue&type=style&index=1&id=af6ed9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ed9e8",
  null
  
)

export default component.exports